import { configureStore } from "@reduxjs/toolkit";
import UserDetailsSlice from "../Redux/UserDetails";
import CourseDetailsSlice from "../Redux/CourseDetails";
import learnersReportReducer from "../Redux/LearnersReport";
import CourseFeedbackReducer from "../Redux/CourseFeedback";
import { IgniteTalksslice } from "../Redux/IgniteTalks";

export default configureStore({
    reducer: {
        userDetails: UserDetailsSlice,
        courseDetails: CourseDetailsSlice,
        learnersReport: learnersReportReducer,
        IgniteTalks: IgniteTalksslice.reducer,
        CourseFeedback: CourseFeedbackReducer
    }
});
